<template>
  <div>
    <div v-if="openType !== 0">
      <el-form style="margin: 20px 40px 0 0" :model="askLeaveForm" :rules="askLeaveRules" ref="askLeaveForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="到期自动取消" prop="">
              <el-radio-group v-model="askLeaveForm.autoReturn">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="办理人员" prop="">
              <el-input disabled v-model="askLeaveForm.espName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="请假开始时间" prop="leaveStart">
              <el-date-picker v-fixZoom style="width: 100%" v-model="askLeaveForm.leaveStart"
                              type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请假结束时间" prop="leaveEnd">
              <el-date-picker v-fixZoom style="width: 100%" v-model="askLeaveForm.leaveEnd"
                              type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="请假原因" prop="">
          <el-input type="textarea" :rows="2" v-model="askLeaveForm.leaveReason" placeholder="请输入原因"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div v-else>
      <el-descriptions style="margin: 0 20px 20px 20px" :column="2" border>
        <el-descriptions-item>
          <template slot="label">
            办理人员
          </template>
          {{askLeaveForm.espName}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            到期自动取消
          </template>
          {{getAutoReturnDesc(askLeaveForm.autoReturn)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            请假开始时间
          </template>
          {{askLeaveForm.leaveStart}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            请假结束时间
          </template>
          {{askLeaveForm.leaveEnd}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            请假原因
          </template>
          {{askLeaveForm.leaveReason}}
        </el-descriptions-item>
      </el-descriptions>
      <el-form style="margin: 20px 20px 0 0" :model="askLeaveCancelForm" ref="askLeaveForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="结束请假原因" prop="">
          <el-input type="textarea" :rows="2" v-model="askLeaveCancelForm.reason" placeholder="请输入原因"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="height: 50px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAskLeave()">
            <span>{{openType === 0 ? '关闭' : '取消'}}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div v-if="openType !== 0" class="send-btn" @click="submitAskLeave('askLeaveForm')">
            <span>确定请假</span>
          </div>
          <div v-else class="send-btn" @click="submitCancelAskLeave">
            <span>结束请假</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  accomodationaskleave,
  accomodationaskleavecancel,
  accomodationgetleaveinfo
} from '../../../api/yanglaoyuan/homebed'

export default {
  name: 'askLeave',
  model: {
    prop: 'askLeaveShow',
    event: 'change'
  },
  props: {
    homeBedPersonObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      pickerOptions: {},
      espId: 0,
      espName: '',
      // 打开类型 1新增 2编辑 0查看
      openType: 0,

      askLeaveForm: {
        eId: 0,
        id: 0,
        espId: 0,
        espName: '',
        autoReturn: 0,
        leaveStart: '',
        leaveEnd: '',
        leaveReason: '',
        opTime: ''
      },
      askLeaveRules: {
        // epId: [{required: true, message: '请选择老人', trigger: 'change'}],
        // org: [{required: true, message: '请选择床位', trigger: 'change'}]
        leaveStart: [
          { required: true, message: '请选择请假开始时间', trigger: 'change' }
        ],
        leaveEnd: [
          { required: true, message: '请选择请假结束时间', trigger: 'change' }
        ]
      },
      askLeaveCancelForm: {
        reason: ''
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      let loginResp = this.$store.state.user.LoginResp
      this.espId = loginResp.syspersonid
      this.espName = loginResp.personname

      this.openType = this.homeBedPersonObj.openType
      this.askLeaveForm.eId = this.homeBedPersonObj.row.eid
      this.askLeaveForm.id = this.homeBedPersonObj.row.id
      if (this.openType === 0) {
        this.getAskLeaveInfo()
      } else {
        this.askLeaveForm.espId = loginResp.syspersonid
        this.askLeaveForm.espName = loginResp.personname
      }
    },

    closeAskLeave () {
      this.$emit('change', false)
    },
    submitAskLeave (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            eid: this.askLeaveForm.eId,
            id: this.askLeaveForm.id,
            esp_id: this.espId,
            esp_name: this.espName,
            auto_return: this.askLeaveForm.autoReturn,
            leave_start: this.askLeaveForm.leaveStart,
            leave_end: this.askLeaveForm.leaveEnd,
            leave_reason: this.askLeaveForm.leaveReason
          }
          accomodationaskleave(data).then(res => {
            this.$notify({title: '成功', message: '成功请假', type: 'success', duration: 2000})
            this.$emit('updateTable')
            this.$emit('change', false)
          })
        }
      })
    },
    submitCancelAskLeave () {
      let data = {
        eid: this.askLeaveForm.eId,
        id: this.askLeaveForm.id,
        esp_id: this.espId,
        esp_name: this.espName,
        reason: this.askLeaveCancelForm.reason
      }
      accomodationaskleavecancel(data).then(res => {
        this.$notify({title: '成功', message: '成功取消请假', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    getAskLeaveInfo () {
      let data = {
        eid: this.homeBedPersonObj.row.eid,
        id: this.homeBedPersonObj.row.id
      }
      accomodationgetleaveinfo(data).then(res => {
        let data = res.data.leaveinfo
        this.askLeaveForm.espName = data.esp_name
        this.askLeaveForm.espId = data.esp_id
        this.askLeaveForm.autoReturn = data.auto_return
        this.askLeaveForm.leaveStart = data.leave_start
        this.askLeaveForm.leaveEnd = data.leave_end
        this.askLeaveForm.leaveReason = data.leave_reason
      })
    },

    // 显示描述
    getAutoReturnDesc (autoReturn) {
      let result = '未知'
      if (autoReturn === 0) {
        result = '否'
      } else if (autoReturn === 1) {
        result = '是'
      }
      return result
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/askLeave.vue